<template>
  <div class="page-cards flex column">
    <resize-observer @notify="__resizeHanlder" />
    <el-row>
      <el-col :span="24">
        <masonry
          v-if="loading || loadingFilter"
          :cols="masonryCols"
          :gutter="10"
        >
          <customer-card
            v-for="(item, index) in [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]"
            :key="index"
            @card-click-action="$emit('card-click-action', $event)"
            :actions="actions"
            :data="item"
            :loading="loadingCard"
          />
        </masonry>

        <!-- { default: 4, 1200: 1, 1000: 1, 480: 1 } -->
        <masonry v-else :cols="masonryCols" :gutter="10">
          <customer-card
            v-for="(item, index) in filterList"
            :key="index"
            :actions="actions"
            :data="item"
            :loading.sync="loadingCard"
            @card-click-action="$emit('card-click-action', $event)"
          />
        </masonry>
      </el-col>
    </el-row>

    <el-row>
      <el-col :sm="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationApi.currentPage"
          :page-sizes="paginationApi.pageSizes"
          :page-size="paginationApi.pageSize"
          :layout="paginationLayout"
          :total="paginationApi.total"
          hide-on-single-page
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import throttle from "lodash/throttle";
import { formatPhoneNumber } from "@/utils";
import LoadingCustomerCardVue from "./LoadingCustomerCard.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

const CustomerCard = () => ({
  component: import("@/components/customers/CustomerCard.vue"),
  loading: LoadingCustomerCardVue
});

export default {
  name: "CustomersListCard",
  components: {
    "customer-card": CustomerCard
  },
  props: {
    loadingCard: {
      type: Boolean,
      default: false,
      required: true
    },
    search: {
      type: String,
      default: null,
      required: false
    },
    seller_filter: {
      type: String,
      default: null,
      required: false
    },
    status_filter: {
      type: String,
      default: "",
      required: false
    },
    //
    customers_filter: {
      type: String,
      default: null,
      required: false
    },
    customer_clasification_filter: {
      type: String,
      defailt: null,
      required: false
    },
    cxc_filter: {
      type: String,
      default: null,
      required: false
    },
    actions: {
      type: Array
    },
    filterList: {
      type: Array,
      default: null,
      required: false
    },
    paginationApi: {
      type: Object,
      required: false,
      default: () => ({
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 30, 50, 100]
      })
    }
  },
  data() {
    return {
      data: {},
      paginationLayout: "total, sizes, prev, pager, next, jumper",
      title: "",
      description: "",
      list: [],
      masonryCols: 4,
      formOpen: false,
      isMounted: false,
      companyId: this.$store.state.user.user.CompanySelected,
      loadingFilter: false,
      statusFilter: ""
    };
  },
  created() {
    if (this.status_filter) {
      this.status_filter = parseInt(this.status_filter);
    }
    this.isMounted = true;
    this.__resizeHanlder();

    this.getItems({ url: "/api/customers" });
  },
  computed: {
    ...mapGetters({
      loading: "rabbey_table/isLoading"
    }),
    ...mapState({
      pagination: (state) => state.rabbey_table.pagination,
      items: (state) => state.rabbey_table.items
    }),
    getCustomers() {
      let items = [];
      try {
        this.items.forEach((item) => {
          const phone = formatPhoneNumber(item.PhoneNumber);
          items.push({
            Image: "/static/images/avatar-2.jpg",
            PhoneNumber: phone,
            ...item
          });
        });
      } catch (_) {
        //
      }
      return items;
    },
    filterData() {
      // var filterable = [];
      // let getTypeParams = typeof this.search;
      // if (getTypeParams != "object") {
      //   if (this.search.trim().length === 0) {
      //     filterable = this.filterByVendorAndStatus;
      //   } else {
      //     // input filter not blanck value
      //     if (this.search !== null) {
      //       if (this.filterList.length > 0) {
      //         filterable = this.filterList.filter(
      //           data =>
      //             !this.search ||
      //             data.Name.toLowerCase().includes(this.search.toLowerCase())
      //         );

      //         let elFilterable = [];
      //         filterable.forEach(item => {
      //           elFilterable.push({
      //             Image: "/static/images/avatar-2.jpg",
      //             ...item
      //           });
      //         });
      //         filterable = elFilterable;
      //       }
      //     } else {
      //       filterable = this.getCustomers;
      //     }
      //   }
      // } else {
      //   filterable = this.filterByVendorAndStatus;
      // }

      return this.filterList;
    },
    filterByVendorAndStatus() {
      let filterable;
      // // por eso agrego la validacion del length para que el componente no sobre escriba y lo muestro.
      // if (this.filterList.length > 0) {
      //   if (this.seller_filter.length > 0) {
      //     filterable = this.filterList.filter(
      //       data =>
      //         !this.seller_filter ||
      //         data.SalesPersonCode.toLowerCase().includes(
      //           this.seller_filter.toLowerCase()
      //         )
      //     );
      //     let elFilterable = [];
      //     filterable.forEach(item => {
      //       elFilterable.push({
      //         Image: "/static/images/avatar-2.jpg",
      //         ...item
      //       });
      //     });
      //     filterable = elFilterable;
      //   } else if (this.status_filter != "") {
      //     filterable = this.filterList.filter(
      //       data =>
      //         !this.statusFilter ||
      //         data.ContractStatus.toLowerCase().includes(
      //           this.statusFilter.toLowerCase()
      //         )
      //     );
      //     let elFilterable = [];
      //     filterable.forEach(item => {
      //       elFilterable.push({
      //         Image: "/static/images/avatar-2.jpg",
      //         ...item
      //       });
      //     });
      //     filterable = elFilterable;
      //   } else if (this.customers_filter > 0) {
      //     filterable = this.filterList.filter(
      //       data =>
      //         !this.customers_filter ||
      //         data.CustomerService.toLowerCase().includes(
      //           this.customers_filter.toLowerCase()
      //         )
      //     );
      //    let elFilterable = [];
      //    filterable.forEach(item => {
      //      elFilterable.push({
      //        Image: "/static/images/avatar-2.jpg",
      //        ...item
      //      });
      //    });
      // filterable = elFilterable;
      //   } else if (this.customer_clasification_filter != null) {
      //     console.log("FILTER FOR: ", this.customer_clasification_filter);
      //     console.log("DATA:", this.filterList);
      //     // filterable = this.filterList.filter(data => {
      //     //   console.log(
      //     //     "FILTRO:",
      //     //     this.customer_clasification_filter,
      //     //     typeof(this.customer_clasification_filter),
      //     //     "CLASIFICATION:",
      //     //     data.Clasification,
      //     //     typeof(data.Clasification)
      //     //   );
      //     //   !this.customer_clasification_filter ||
      //     //     data.Clasification === this.customer_clasification_filter;
      //     // });
      //     filterable = this.filterList;
      //     console.log("FILTERABLE:", filterable);
      //     let elFilterable = [];
      //     filterable.forEach(item => {
      //       elFilterable.push({
      //         Image: "/static/images/avatar-2.jpg",
      //         ...item
      //       });
      //     });
      //   }
      // } else {
      //   // input filter with blanck value
      //   filterable = this.getCustomers;
      // }

      // if (this.seller_filter.length > 0) {
      //   filterable = this.filterList;
      // } else {
      //   if (this.status_filter != "" || this.cxc_filter != "") {
      //     filterable = this.filterList;
      //   } else if (this.customers_filter > 0) {
      //     filterable = this.filterList;
      //   } else {
      //     filterable = this.getCustomers;
      //   }
      // }
      filterable = this.filterList;
      return filterable;
    }
  },
  methods: {
    formatPhoneNumber,
    ...mapActions({
      paginate: "rabbey_table/paginate",
      getItems: "rabbey_table/getItems"
    }),
    ...mapMutations({
      setOriginItems: "rabbey_table/originalItems",
      setUrl: "rabbey_table/url"
    }),
    // eslint-disable-next-line no-unused-vars
    __resizeHanlder: throttle(function (e) {
      if (window.innerWidth <= 480) {
        this.masonryCols = 1;
        this.paginationLayout = "sizes, prev, pager, next";
      } else if (window.innerWidth <= 600) {
        this.masonryCols = 1;
        this.paginationLayout = "total, sizes, prev, pager, next";
      } else if (window.innerWidth <= 700) {
        this.masonryCols = 2;
        this.paginationLayout = "total, sizes, prev, pager, next";
      } else if (window.innerWidth <= 800) {
        this.masonryCols = 2;
        this.paginationLayout = "total, sizes, prev, pager, next, jumper";
      } else if (window.innerWidth <= 1000) {
        this.masonryCols = 2;
        this.paginationLayout = "total, prev, pager, next, jumper";
      } else if (window.innerWidth <= 1200) {
        this.masonryCols = 2;
        // this.paginationLayout = "sizes, prev, pager, next";
      } else {
        this.paginationLayout = "total, sizes, prev, pager, next, jumper";
        this.masonryCols = 3;
      }
    }, 700),
    onClickOutside() {
      this.formOpen = false;
    },
    openForm() {
      this.formOpen = true;
    },
    closeForm() {
      setTimeout(this.onClickOutside, 100);
    },
    handleSizeChange(val) {
      this.$emit("update-page-size", val);
    },
    handleCurrentChange(val) {
      this.$emit("update-current-page", val);
    }
  }
};
</script>

<style lang="scss">
.page-sales {
  .page-header {
    margin-bottom: 20px;
  }

  .list {
    padding: 10px 20px;
    margin: 0 -20px;
    margin-top: 20px;

    .masonry {
      column-count: 4;
      column-gap: 40px;
    }
  }
}

/* Masonry on large screens */
@media (max-width: 1200px) {
  .page-sales {
    .list {
      .masonry {
        column-count: 3;
      }
    }
  }
}

/* Masonry on medium-sized screens */
@media (max-width: 1000px) {
  .page-sales {
    .list {
      .masonry {
        column-count: 2;
      }
    }
  }
}

/* Masonry on small screens */
@media (max-width: 480px) {
  .page-sales {
    .list {
      .masonry {
        column-count: 1;
      }
    }
  }
}
</style>
